/**
 * Promo/Event/News Block.
 * 
 */

/**
 * Promo/Event/News Slider.
 * Mobile: Fading single slide carousel.
 * Desktop: Fading single slide carousel.
 */

// Set up slick slider for Promo/Event/News slides.
let 
	types = ['promos','events','news'];

function initSliders() {
	console.log('PROMO/EVENT/NEWS: initSliders()');

	$.each(types, function(index, value) {
		let
			$myMustsSlider = $('.'+value+' .promo-news-event__slides'),
			myMustsSliderSettings = {
				adaptiveHeight: true,
				arrows: false,
				autoplay: false,
				// autoplaySpeed: 3000,
				// centerMode: true,
				// centerPadding:'30px',
				// cssEase:'ease-out',
				dots: true,
				draggable: false,
				appendDots: $('.'+value+' .musts-block__dot-nav'),
				fade: true,
				// focusOnSelect:true,
				infinite: true,
				mobileFirst: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				swipeToSlide: true,
				variableWidth: false,
			};
	
		$myMustsSlider.slick(myMustsSliderSettings);
	});
}

exports.init = function () {
	console.log('PROMO/EVENT/NEWS: exports.init');
	// Run init methods...

	initSliders();
};

